<template>
    <div class="conifer-test">

        <h1>Conifer test page</h1>

        <b-row>
            <b-col>
                <b-card no-body>
                    <b-card-header>
                        <h5>Scores from last survey</h5>
                    </b-card-header>
                    <b-card-body>
                        <table class="table">
                            <thead>
                            <tr>
                                <th></th>
                                <th>Actual</th>
                                <th>Target</th>
                            </tr>
                            </thead>
                            <tbody v-for="(score,s) in scoresFormatted" :key="s">
                            <tr v-if="score.name != 'caseIndex'">
                                <td>{{ score.name }}</td>
                                <td>{{ score.value }}</td>
                                <td>{{ score.target }}</td>
                                <td>
                                    <div v-if="!score.skipCompare">
                                        <b-icon-check-circle-fill variant="success" v-if="score.ok"/>
                                        <b-icon-x-circle-fill variant="danger" v-if="!score.ok"/>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col>
                <b-form action="http://wcd-api.test?r=conifer" method="POST">
                    <b-card no-body>
                        <b-card-header>
                            <h5>Post simulated Conifer data for a new survey</h5>
                        </b-card-header>
                        <b-card-body>
                            <input type="hidden" name="RETURN_URL" :value="returnUrl"/>
                            <b-row>
                                <b-col>
                                    <label>Select test case ({{ caseIndex }})</label>
                                    <select name="caseIndex" v-model="caseIndex" class="mb-2">
                                        <option v-for="i in cases.length - 1" :value="i" :key="i">
                                            {{ cases[i].name }}
                                        </option>
                                    </select>
                                    <input name="caseIndex" type="hidden" :value="caseIndex"/>
                                </b-col>
                                <b-col class="text-right">
                                    <input type="submit" class="mt-3">
                                </b-col>
                            </b-row>
                        </b-card-body>
                    </b-card>
                    <b-card no-body>
                        <b-card-body>
                            <div v-for="(f,i) in coniferFields" :key="i">
                                <label>{{ f }}</label>
                                <input type="text" :name="f" v-model="currentCase[f]">
                            </div>
                        </b-card-body>
                    </b-card>
                </b-form>
            </b-col>
        </b-row>

    </div>
</template>

<script>
/* eslint-disable */

import Vue from 'vue'

/**
 * Component to simulate data being posted to the /conifer backend URL by the Conifer portal.
 * We use a primitive HTML form for this purpose.
 * The backend action will store the data, then redirect to the /conifer frontend URL (our Conifer component).
 */

import ConiferTestMixin from "@/providers/ConiferTestMixin"
import conifer from "@/pages/Conifer.vue";
import * as _ from 'lodash'

export default Vue.extend({
    name: "ConiferTest",
    mixins: [ConiferTestMixin],
    props: {
        scores: String
    },
    data() {
        return {
            // in local dev mode, we post the calculated scores back to our score-test action
            // (which redirects back to this component)
            returnUrl: "http://wcd-api.test?r=conifer/score-test",
            caseIndex: 0, // index of selected test case

            // see ConiferTestMixin:
            // coniferFields
            // cases
            // targetScores
        }
    },
    computed: {
        conifer() {
            return conifer
        },
        currentCase() {
            return this.cases[this.caseIndex]
        },
        scoresFormatted() {
            if (!this.scores) {
                return []
            }
            const scoreObj = JSON.parse(atob(this.scores))
            console.log(scoreObj)
            this.caseIndex = +scoreObj.caseIndex
            return _.map(_.keys(scoreObj), (key) => {
                const keyVal = scoreObj[key]
                let val = keyVal
                let ok = true
                let target = null
                let skipCompare = _.endsWith(key, '_ADVICE') ||
                    _.endsWith(key, '_THRESHOLDS') ||
                    _.endsWith(key, '_HIGHER_IS_BETTER') ||
                    _.endsWith(key, '_ID') ||
                    _.endsWith(key, '_OPTIN') ||
                    _.startsWith(key, 'RESPONSE_') ||
                    key == 'KEY' ||
                    key == 'EXIT_METHOD'

                if (key.indexOf('RESPONSE_') != -1) {
                    ok = true
                } else {
                    val = parseFloat(+keyVal).toFixed(1)
                    if (key.indexOf('FRAMINGHAM') != -1) {
                        val = parseFloat(+keyVal).toFixed(4)
                    }
                    if (parseInt(+keyVal) === +keyVal) {
                        val = parseInt(+keyVal)
                    }
                    if (isNaN(val)) {
                        val = null
                    }

                    target = this.targetScores[this.scoreTargetIndex][key]
                    ok = Math.abs(val - target) < 0.1
                }
                return {name: key, value: val, target: target, ok: ok, skipCompare: skipCompare}
            })
        },
        lastCaseIndex() {
            const scoreObj = JSON.parse(atob(this.scores))
            return scoreObj.caseIndex
        },
        scoreTargetIndex() {
            const targetCase = this.cases[this.lastCaseIndex]
            return targetCase.targetIndex
        }
    }
})

</script>

